/** Resolve clip tag → Videos tab location for seek / trim. */

export function normalizeEditHintsForClient(editHints) {
  if (!editHints || typeof editHints !== 'object') return null;
  const out = { ...editHints };
  if (out.transcriptFile) {
    out.transcriptFileNote = 'Transcript path is local to the mapper machine.';
    delete out.transcriptFile;
  }
  return out;
}

export function findClipByTag(selectedData, sectionKey, tag, preferredUrl) {
  const t = (tag || '').trim();
  if (!t) return null;
  const tree = selectedData?.[sectionKey]?.clips || [];
  for (const charClip of tree) {
    for (const video of charClip.videos || []) {
      if (preferredUrl && video.url !== preferredUrl) continue;
      const idx = (video.vidclips || []).findIndex(c => (c.tag || '').trim() === t);
      if (idx >= 0) {
        return {
          character: charClip.characterName,
          url: video.url,
          clipIndex: idx,
          clip: video.vidclips[idx],
        };
      }
    }
  }
  for (const charClip of tree) {
    for (const video of charClip.videos || []) {
      const idx = (video.vidclips || []).findIndex(c => (c.tag || '').trim() === t);
      if (idx >= 0) {
        return {
          character: charClip.characterName,
          url: video.url,
          clipIndex: idx,
          clip: video.vidclips[idx],
        };
      }
    }
  }
  return null;
}

export function clipHintForTag(editHints, tag) {
  return (editHints?.clips || []).find(c => (c.tag || '').trim() === (tag || '').trim()) || null;
}

/** Cut hint row for a Videos-tab clip (matched by tag). */
export function cutHintForClip(editHints, clip) {
  const tag = (clip?.tag || '').trim();
  if (!tag || !editHints) return null;
  return clipHintForTag(editHints, tag);
}

/** Start/end for preview — saved clip times, then hint range. */
export function timelineCutsForTag(editHints, tag) {
  const t = (tag || '').trim();
  if (!t || !editHints) return [];
  return (editHints.cuts || []).filter(
    c => (c.afterTag || '').trim() === t || (c.beforeTag || '').trim() === t,
  );
}

export function previewRangeForClip(clip, hint) {
  const start = (clip?.startTime || '').trim()
    || hint?.range?.start
    || hint?.anchors?.in?.time
    || '';
  const end = (clip?.endTime || '').trim()
    || hint?.range?.end
    || hint?.anchors?.out?.time
    || '';
  return { start, end };
}
